/* ==========================================================================
   NUA DREAMS — sitio.js
   Lo que es de toda la tienda y no de una pieza concreta:

     · avisar al lector de pantalla de lo que cambia sin recargar
     · escapar texto antes de meterlo en el HTML
     · hablar con Shopify (fetch con JSON y con manejo de error de verdad)
     · pedirle a Shopify una sección ya pintada

   Va primero: lo usan la cesta, el buscador y la ficha de producto.

   Escrito con var y funciones, sin flechas ni módulos: es el estilo del resto
   del JavaScript del tema y así los cinco archivos se leen igual.
   ========================================================================== */

var NuaSitio = (function () {

  var config = window.Nua || {};
  var rutas = config.rutas || {};
  var textos = config.textos || {};

  /* Escapa lo que va a acabar dentro de innerHTML. Casi todo el HTML de la
     tienda lo pinta Shopify, que ya escapa por su cuenta; esto es para lo poco
     que se construye aquí. */
  function escapar(texto) {
    return String(texto == null ? "" : texto)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  /* Dice algo en la región viva de la página. Sin esto, quien usa lector de
     pantalla añade una vela a la cesta y no se entera de nada: el cambio
     ocurre en un panel que acaba de aparecer y el número de la cabecera es
     decorativo. */
  function anunciar(mensaje) {
    var caja = document.querySelector("[data-anuncio]");
    if (!caja) return;
    /* Vaciar primero: si el mensaje es idéntico al anterior, un lector de
       pantalla no vuelve a leerlo. */
    caja.textContent = "";
    window.setTimeout(function () { caja.textContent = mensaje; }, 60);
  }

  /* Una petición JSON a Shopify.

     Lo importante es que fetch NO falla con un 422: devuelve una respuesta con
     ok=false y el cuerpo lleva el motivo («no queda stock de Brownie»). Si no
     se mira el ok, un error de stock se trata como un acierto y la cesta se
     queda diciendo una cosa distinta de lo que hay. Por eso esto rechaza con
     el mensaje que manda Shopify, que además viene en el idioma de la tienda.

     Y sólo con ése. Si lo que vuelve no es JSON (la página de «demasiadas
     peticiones», un reto de Cloudflare) o la red se ha caído, el motivo que
     daría el navegador es un «Unexpected token <» o un «Failed to fetch»,
     que no le dicen nada a nadie: entonces va la frase genérica de la
     tienda. Los errores que salen de aquí llevan la marca `tienda`, para que
     quien los recoge sepa que su texto se puede enseñar tal cual. */
  function fallo(motivo) {
    var error = new Error(motivo || textos.cestaError || "Error");
    error.tienda = true;
    return error;
  }

  /* Shopify no lo dice siempre en el mismo sitio: las rutas .js lo mandan en
     description o en message, y alguna vez llega como {errors: "…"}. */
  function motivoDe(datos) {
    if (!datos) return null;
    var campos = [datos.description, datos.message, datos.errors];
    for (var i = 0; i < campos.length; i++) {
      if (typeof campos[i] === "string" && campos[i].trim()) return campos[i];
    }
    return null;
  }

  /* Sin cuerpo es una lectura (GET): la cesta tal como está, /cart.js. */
  function pedir(url, cuerpo) {
    var opciones = { headers: { "Accept": "application/json" } };
    if (cuerpo !== undefined) {
      opciones.method = "POST";
      opciones.headers["Content-Type"] = "application/json";
      opciones.body = JSON.stringify(cuerpo);
    }
    return fetch(url, opciones).then(function (respuesta) {
      return respuesta.json()
        .catch(function () { return null; })
        .then(function (datos) {
          if (!respuesta.ok || !datos) throw fallo(motivoDe(datos));
          return datos;
        });
    }, function () {
      /* La petición ni siquiera ha salido (sin conexión, cortada) */
      throw fallo();
    });
  }

  /* Saca de una respuesta de Shopify una sección ya pintada y devuelve su
     primer elemento. La API la manda como texto con el envoltorio
     #shopify-section-…, así que hay que convertirla en nodos antes de nada. */
  function seccion(html, selector) {
    var molde = document.createElement("div");
    molde.innerHTML = html;
    return molde.querySelector(selector);
  }

  return {
    rutas: rutas,
    textos: textos,
    escapar: escapar,
    anunciar: anunciar,
    pedir: pedir,
    fallo: fallo,
    seccion: seccion
  };
})();
